import { render, staticRenderFns } from "./AppAnnouncementsHost.vue?vue&type=template&id=c7955eb6&scoped=true"
import script from "./AppAnnouncementsHost.vue?vue&type=script&lang=js"
export * from "./AppAnnouncementsHost.vue?vue&type=script&lang=js"
import style0 from "./AppAnnouncementsHost.vue?vue&type=style&index=0&id=c7955eb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7955eb6",
  null
  
)

export default component.exports